export const API_ROUTES = {
  AUTH: {
    ME: '/api/auth/me/',
    UPDATE_ME: '/api/auth/me/',
    CHANGE_PASSWORD: '/api/auth/me/password/',
    AVATAR: '/api/auth/me/avatar/',
    AVATAR_CONFIRM: '/api/auth/me/avatar/confirm/',
    LOGIN: '/api/auth/login/',
    LOGOUT: '/api/auth/logout/',
    FORGOT_PASSWORD: '/api/auth/forgot-password/',
    RESET_PASSWORD: '/api/auth/reset-password/',
    VERIFY_EMAIL: '/api/auth/verify-email/',
    RESEND_VERIFICATION_EMAIL: '/api/auth/resend-verification-email/',
  },
  SUBSCRIPTION: {
    BASE: '/api/subscription/',
    CANCEL: '/api/subscription/cancel/',
  },
  USERS: {
    BASE: '/api/users/',
    BY_ID: (id: string) => `/api/users/${id}/`,
    PASSWORD: (id: string) => `/api/users/${id}/password/`,
    COMMISSION: (id: string) => `/api/users/${id}/commission/`,
    TOGGLE_ACTIVE: (id: string) => `/api/users/${id}/toggle-active/`,
  },
  APPOINTMENTS: {
    BASE: '/api/appointments/',
    BY_ID: (id: string) => `/api/appointments/${id}/`,
    STATUS: (id: string) => `/api/appointments/${id}/status/`,
  },
  SERVICES: {
    BASE: '/api/services/',
    BY_ID: (id: string) => `/api/services/${id}/`,
  },
  SCHEDULE_BLOCKS: {
    BASE: '/api/schedule-blocks/',
    BY_ID: (id: string) => `/api/schedule-blocks/${id}/`,
  },
  PATIENTS: {
    BASE: '/api/patients/',
    BY_ID: (id: string) => `/api/patients/${id}/`,
  },
  INSURANCES: {
    BASE: '/api/insurances/',
    BY_ID: (id: string) => `/api/insurances/${id}/`,
  },
  PACKAGES: {
    BASE: '/api/packages/',
    BY_ID: (id: string) => `/api/packages/${id}/`,
    BY_PATIENT: (id: string) => `/api/packages/patient/${id}`,
  },
  EVOLUTION_TEMPLATES: {
    BASE: '/api/evolution-templates/',
    BY_ID: (id: string) => `/api/evolution-templates/${id}/`,
  },
  FINANCIAL: {
    PAYMENTS: '/api/payments/',
    EXPENSES: '/api/expenses/',
    REPASSES: '/api/repasses/',
  },
  ATTACHMENTS: {
    BY_PATIENT: (patientId: string) => `/api/patients/${patientId}/attachments/`,
    CONFIRM: (id: string) => `/api/attachments/${id}/confirm/`,
    DOWNLOAD_URL: (id: string) => `/api/attachments/${id}/download-url/`,
    BY_ID: (id: string) => `/api/attachments/${id}/`,
  },
  SIGNUP: {
    BASE: '/api/signup/',
    PLANS: '/api/signup/plans/',
    STATUS: '/api/signup/status/',
  },
};
